document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuButton = document.querySelector(
    ".aside-custom-facet--mobile-menu"
  );
  const modalCloseMenuButton = document.querySelector(
    ".aside-custom-facet--mobile-close"
  );
  const facetWrapper = document.querySelector(".aside-custom-facet");
  mobileMenuButton.addEventListener("click", function () {
    facetWrapper.classList.toggle("open");
  });
  modalCloseMenuButton.addEventListener("click", function () {
    facetWrapper.classList.remove("open");
  });

  // Brand filters are mutually exclusive — clicking a brand replaces the active one
  document.querySelectorAll(".aside-custom__filter-brand a").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetUrl = new URL(this.href, window.location.origin);
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);
      const targetParams = new URLSearchParams(targetUrl.search);

      // Find the filter param key/value that url_to_add is adding (not present in current URL)
      let brandKey = null;
      let brandValue = null;

      targetParams.forEach(function (value, key) {
        if (!currentParams.getAll(key).includes(value)) {
          brandKey = key;
          brandValue = value;
        }
      });

      if (brandKey !== null) {
        // Remove all existing values for this filter key, then apply only the new one
        currentParams.delete(brandKey);
        currentParams.append(brandKey, brandValue);
        window.location.href = currentUrl.pathname + "?" + currentParams.toString();
      } else {
        // Filter already active — navigate as-is (Shopify will handle it)
        window.location.href = this.href;
      }
    });
  });
});
